import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';
import { setCreateNewOrderData } from '../coilovers/orders/createNewOrder';

const fillOrderData = (data) => {
  const {
    order_marketplace_name: marketplace,
    order_marketplace_account: account,
    order_marketplace_sold_date: soldDate,
    order_marketplace_number: marketplaceNumber,
    order_subtotal: totalPrice,
    order_listings_title: title,
    order_shipping_full_name: fullName,
    order_shipping_address: address,
    order_shipping_address_line2: address2,
    order_shipping_country: country = 'US',
    order_shipping_state: state = 'AK',
    order_shipping_zip: zip,
    order_shipping_city: city,
    order_shipping_phone: phone,
    order_shipping_email: email,
    items: {
      listing_sku: listingSku,
      totalSize: {
        listing_width: totalWidth,
        listing_height: totalHeight,
        listing_length: totalLength,
        listing_weight: totalWeight
      },
      listing_vehicle_compatible_cars: compatibleCar
    }
  } = data;
  const price = (parseFloat(totalPrice) * 0.7).toFixed(2);

  return {
    mpn: listingSku?.join(','),
    marketplace,
    marketplaceNumber,
    account,
    soldDate,
    totalPrice: price,
    totalPriceOriginal: parseFloat(totalPrice),
    title,
    weight: totalWeight,
    width: totalWidth,
    height: totalHeight,
    length: totalLength,
    firstName: fullName?.split(' ')[0],
    lastName: fullName?.split(' ')[1] || '',
    address,
    address2,
    country,
    state,
    zip,
    city,
    phone,
    email,
    declared: price,
    make: compatibleCar?.make,
    model: compatibleCar?.model,
    yearRange: compatibleCar?.year,
  };
};

const getOrderByPo = createAsyncThunk(
  'general/getOrderByPo',
  async (po, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await authGet(`/general/getOrderByPo/${po}`);
      if (data?.data) {
        dispatch(setCreateNewOrderData(fillOrderData(data?.data)));
        return data.data;
      }
      return rejectWithValue('Order nor found');
    } catch (error) {
      return rejectWithValue(error?.data?.message || 'Error');
    }
  }
);

export const clearGetOrderByPo = createAction('clearGetOrderByPo');
export const clearErrorGetOrderByPo = createAction('clearErrorGetOrderByPo');

export default getOrderByPo;
